import { HttpParams } from '@angular/common/http';
import { BaseModel } from '@model/base-model';
import { SearchResult } from '@model/search-result';
import { Constants } from '@shared/constants';
import { debounceTime, distinctUntilChanged, map, Observable } from 'rxjs';

import { BaseService } from './base.service';

export abstract class BaseSearchService<
  T extends BaseModel,
> extends BaseService {
  search(query: string): Observable<T[]> {
    const url = `${this.baseUrl}/search`;

    const params = new HttpParams()
      .set('page', 0)
      .set('size', Constants.SEARCH_PAGE_SIZE)
      .set('query', query);

    return this.httpClient.get<SearchResult<T>>(url, { params }).pipe(
      distinctUntilChanged(),
      debounceTime(600),
      map(searchResult => searchResult.content),
    );
  }
}
